import React, { useContext, useEffect, useState } from "react";
import style from "./styles/OTP.module.css"
import { submitCaptcha } from "../../Utils/captcha";
import { sendLoginOTPCodeEmail } from "../../Utils/sendLoginOTPCodeEmail";
import authImg from "./styles/images/sec.png";
import emailImg from "./styles/images/sms.svg";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../Context/changeLanguageProvider";

export function MFAOptions ({options, setShowOptions, setMethod}){
    const [loading, setLoading] = useState()
    const websiteCurrentLang = useContext(LanguageContext).language;

    const [content, setContent] = useState(
        websiteCurrentLang.content.Login.MFAoptions
    );
    const [dublicatedcontent, setDublicatedContent] = useState(
        websiteCurrentLang.content.DublicatedText
    );
    useEffect(() => {
        setContent(websiteCurrentLang.content.Login.MFAoptions);
        setDublicatedContent(websiteCurrentLang.content.DublicatedText);
    }, [websiteCurrentLang]);
    const navigate = useNavigate()
    const handleEmail = () =>{
        setLoading({"email":true})
        submitCaptcha()
        .then(token=>{
            if (!token) throw new Error (content.MFAoptionsCaptchaError1)
            return sendLoginOTPCodeEmail(token)
        }).then(res=>{
                if (res.status===200) return
                if (res.status===404) throw new Error(content.MFAoptionsNoOTPError)
                if (res.status===498) throw new Error(dublicatedcontent.dublicatedText49);
                else throw new Error(dublicatedcontent.dublicatedText78)
        })
        .then(e=>{
            setMethod('email')
            setShowOptions(false)
        })
        .catch(e=>{
            setLoading()
            console.log(e)
        })
    }
    const handleAuthenticator = () =>{
        setMethod('authenticator')
        setShowOptions(false)
    }
    return(
    <div className={style.main_box_options}>
        <div className={style.options_title}>
            {content?.MFAoptionsText1}
        </div>
        {options?.authenticator&&<div onClick={()=>handleAuthenticator()} className={style.option_card}>
            <img className={style.img} src={authImg} />
            <span>{content.MFAoptionsText2}</span>
        </div>}
        {options?.email&&<div onClick={()=>handleEmail()} className={style.option_card}>
            <img className={`${style.img} ${style.img_email}`} src={emailImg} />
            <span className={loading?.email&&style.status}>{content.MFAoptionsText3}</span>
        </div>}

        <div className={style.otp_rect}></div>
        <a onClick={()=>navigate('/login')} className={style.otp_link}>{content?.MFAoptionsText4}</a>
    </div>
    )
}